export default __webpack_public_path__ + "static/media/003-bad habits.0abb19c1.svg";